"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistOrLoginRequest = void 0;
var RegistOrLoginRequest = /** @class */ (function () {
    function RegistOrLoginRequest() {
    }
    return RegistOrLoginRequest;
}());
exports.RegistOrLoginRequest = RegistOrLoginRequest;
;
//# sourceMappingURL=registOrLogin.request.js.map